import React from 'react';
import FadeIn from './ui/FadeIn';
import SafeIcon from '../common/SafeIcon';
import { FiStar, FiTag, FiMapPin, FiFileText } from 'react-icons/fi';

const features = [
  { icon: FiStar, text: "Custom Wrapped designs on every vase" },
  { icon: FiTag, text: "One flat wholesale price at $20 / per vase" },
  { icon: FiMapPin, text: "Free local delivery on 8+ vases" },
  { icon: FiFileText, text: "Tax-exempt ordering for resellers" },
];

export default function WhySmileVase() {
  return (
    <section className="py-24 bg-warmWhite">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <FadeIn>
            <h2 className="font-heading text-4xl font-bold mb-6">Why Partner With SmileVase?</h2>
            <p className="text-gray-600 mb-10 font-light leading-relaxed max-w-lg">
              We eliminate the headaches of custom sourcing. No massive minimums, no hidden setup fees—just beautiful, ready-to-sell vases that make your floral designs pop.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, idx) => (
                <div key={idx} className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-sm border border-gray-100">
                  <div className="text-blush mt-1">
                    <SafeIcon icon={feature.icon} className="w-5 h-5" />
                  </div>
                  <p className="text-sm font-medium text-charcoal">{feature.text}</p>
                </div>
              ))}
            </div>
          </FadeIn>
          
          <FadeIn delay={0.2} className="relative aspect-square md:aspect-auto md:h-[600px] rounded-2xl overflow-hidden">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvcG5n/094402f46f724d21891fee07e9a0051e.png" 
              alt="Florist admiring a new baby themed custom vase" 
              className="absolute inset-0 w-full h-full object-cover"
            />
          </FadeIn>
        </div>
      </div>
    </section>
  );
}